import { render } from "./BasicFormComponent.vue?vue&type=template&id=cfb7584e"
import script from "./BasicFormComponent.vue?vue&type=script&lang=js"
export * from "./BasicFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__